// extracted by mini-css-extract-plugin
export default {"title":"movieDetailContent_title__Oa3+I","titleCinema":"movieDetailContent_titleCinema__tMn4D"};